import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PublicSalesAvailabilityBadgeCssClassProviderService } from '../providers/public-sales-availability-badge-css-class-provider.service';
import { PublicAvailability } from '../enums/public-availability';

@Pipe({
  name: 'publicSalesAvailabilityBadgeCssClass',
  standalone: true,
})
export class PublicSalesAvailabilityBadgeCssClassPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly provider = inject(PublicSalesAvailabilityBadgeCssClassProviderService);

  public transform(status: PublicAvailability): Observable<string> {
    return this.provider.css(status);
  }
}
